import { isEmpty, clone } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import InputColorRadio from 'commons-forms/components/InputColorRadio/InputColorRadio.jsx';
import 'commons-forms/components/InputColorRadio/InputColorRadio.scss';

class InputRadioContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleColorRadioChange = this.handleColorRadioChange.bind(this);
    }

    handleColorRadioChange(name, value) {
        this.props.onChange(name, value);
    }

    render() {
        const parentClasses = clone(this.props.classNames);
        if (!this.props.isValid && this.props.hasBeenSubmit) {
            parentClasses.push('field-error');
        }
        const options = this.props.options.map((option) => (
            <InputColorRadio
                onChange={this.handleColorRadioChange}
                name={option.description}
                value={option.htmlColour}
                isSelected={option.htmlColour === this.props.value}
                key={`${option.description}-${option.htmlColour}`}
                disabled={this.props.disabled}
            />
        ));

        return (
            <div className={parentClasses.join(' ')}>
                <div>{options}</div>
                <div className="clearfix">
                    {!isEmpty(this.props.errorLabel) && <p className="errors-input">{this.props.errorLabel}</p>}
                </div>
            </div>
        );
    }
}

InputRadioContainer.defaultProps = {
    options: [],
    disabled: false,
};

InputRadioContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

InputRadioContainer.displayName = 'InputRadioContainer';

export default InputRadioContainer;
